import { render, staticRenderFns } from "./SatScores.vue?vue&type=template&id=0283bf0c&scoped=true&"
import script from "./SatScores.vue?vue&type=script&lang=js&"
export * from "./SatScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283bf0c",
  null
  
)

export default component.exports